export const initialUserState = {
    logined:"unknown",
    username : "",
    id:"",
    level:"normal",
    loadingForLogin : false,
    loadingForLoginCheck : false,
    errorMessageInLogin:null,
}

export const UserReducer = (state, action) => {
    switch( action.type ){
        case 'CHECKING_LOGIN' : 
            return {
                ...state,
                logined: "unknown",
                loadingForLogin : false,
                loadingForLoginCheck : true,
            }
        case 'REQUEST_LOGIN' :
            return {
                ...state,
                logined: false,
                loadingForLogin : true,
                loadingForLoginCheck : false,
            }
        case 'LOGIN_SUCCESS' : 
            return {
                ...state,
                logined: true,
                username:action.payload.username,
                id:action.payload.id,
                level:action.payload.level,                
                loadingForLogin : false,
                loadingForLoginCheck : false,
            }
        case 'LOGOUT' :
            console.log("logout start!")
            return {
                ...initialUserState,
                logined:false,
            }
        case 'LOGIN_ERROR' :
            return {
                ...state,
                loadingForLogin : false,
                loadingForLoginCheck : false,
                errorMessageInLogin : action.error,
            }
        default :
            throw new Error(`Unhandled action type: ${action.type}`);
    }
}